import { getCookie } from '../../utils/cookie';
import doneStageStore from './store';


export function initDoneStageForm() {
	const wrapper = document.getElementById('done-stage');
	if (!wrapper) return;

	const input = wrapper.querySelector('input');
	const button = wrapper.querySelector('.submit');
	if (!button || !input) return;

	input.addEventListener('input', () => {
		button.disabled = input.value.trim() === '';
	});

	button.addEventListener('click', () => {
		const weight = input.value.trim();
		if (weight === '') {
			wpcore.alert('error', wpcore.direct_t({ en: 'Please enter your weight', fr: 'Veuillez entrer votre poids' }));
			return;
		}
		button.disabled = true;

		doneStageStore.setActualStage(weight);

		// Set cookie with 15 minutes expiration
		const date = new Date();
		date.setTime(date.getTime() + (15 * 60 * 1000));
		document.cookie = `temp_weight=${weight}; expires=${date.toUTCString()}; path=/`;

		wpcore.showPopup('stage-assessment');
	});

	// When stage-assessment popup is closed, reset input & button
	document.addEventListener('popup-closed', (e) => {
		if (e.detail.target === 'stage-assessment') {
			input.value = '';
			button.disabled = true;
		}
	});

	const spinnerButtons = wrapper.querySelectorAll('.spinner-btn');
	spinnerButtons.forEach(button => {
		button.addEventListener('click', () => {
			const input = wrapper.querySelector('input');
			const value = Number(input.value);
			if (button.classList.contains('spinner-up')) {
				input.value = Number(value + 0.1).toFixed(1);
			} else {
				input.value = Number(value - 0.1).toFixed(1);
			}
		});
	});
}

/* eslint-disable */

/**
 * Assessment Form Submission Handler
 *
 * Handles form submission for stage assessment
 */

/**
 * Get cookie value by name
 * @param {string} name Cookie name
 * @returns {string|undefined} Cookie value
 */

/**
 * Collect answers from the form
 * @param {HTMLElement} form Form element
 * @returns {Object} Object containing questions and answers
 */
const collectAnswers = (form) => {
	const answers = {};
	const questions = form.querySelectorAll('[data-question-index]');

	questions.forEach((questionEl, index) => {
		// Get question title
		const titleEl = questionEl.closest('.assessment-questions').querySelector('.assessment-question');
		const questionTitle = titleEl
			? titleEl.textContent.trim().replace(/^\d+\.\s*/, '').replace(/\s*\*$/, '')
			: `${wpcore.direct_t({ en: 'Question', fr: 'Question' })} ${index + 1}`;

		let answer = '';

		// Check if it's a progress type (has progress-input)
		const progressInput = questionEl.querySelector('.progress-input');
		if (progressInput) {
			answer = progressInput.value || '';
		} else {
			// It's an input type - find the text input
			const textInput = questionEl.closest('.assessment-questions').querySelector('input[type="text"]');
			if (textInput) {
				answer = textInput.value || '';
			}
		}

		// Only add non-empty answers
		if (answer && answer.trim() !== '') {
			answers[questionTitle] = answer;
		}
	});

	return answers;
};

/**
 * Handle form submission
 * @param {Event} e Submit event
 * @param {HTMLElement} form Form element
 */
const handleSubmit = async (e, form) => {
	e.preventDefault();

	const submitBtn = form.querySelector('button[type="submit"]');
	const originalText = submitBtn.textContent;
	submitBtn.disabled = true;
	submitBtn.textContent = wpcore.direct_t({ en: 'Submitting...', fr: 'Envoi en cours...' });

	// 1. Validate Context (Journey & Stage)
	const journeyId = form.dataset.journeyId;
	const stageId = form.dataset.stageId;

	if (!journeyId || !stageId || journeyId === '0' || stageId === '0') {
		alert(wpcore.direct_t({ en: 'Error: Journey or Stage information is missing', fr: 'Erreur : les informations du parcours ou de l\'\u00e9tape sont manquantes' }));
		console.error('Missing journey_id or stage_id');
		submitBtn.disabled = false;
		submitBtn.textContent = originalText;
		return;
	}

	// 2. Validate Session (Temp Weight Cookie)
	if (!getCookie('temp_weight')) {
		alert(wpcore.direct_t({ en: 'Session expired. Please update your weight again.', fr: 'Session expir\u00e9e. Veuillez mettre \u00e0 jour votre poids \u00e0 nouveau.' }));
		wpcore.closePopup("stage-assessment");
		submitBtn.disabled = false;
		submitBtn.textContent = originalText;
		return;
	}

	// 3. Collect Answers
	const answers = collectAnswers(form);

	if (Object.keys(answers).length === 0) {
		alert(wpcore.direct_t({ en: 'Please answer at least one question before submitting', fr: 'Veuillez r\u00e9pondre \u00e0 au moins une question avant de soumettre' }));
		submitBtn.disabled = false;
		submitBtn.textContent = originalText;
		return;
	}

	// 4. Prepare FormData
	const formData = new FormData();
	formData.append('action', 'save_assessment');

	const nonceInput = form.querySelector('input[name="assessment_nonce"]');
	formData.append('nonce', nonceInput ? nonceInput.value : '');
	formData.append('actual_weight', doneStageStore.getActualWeight());
	formData.append('journey_id', journeyId);
	formData.append('stage_id', stageId);

	for (const [question, answer] of Object.entries(answers)) {
		formData.append(`answers[${question}]`, answer);
	}

	// 5. Submit Data

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
		});

		const result = await response.json();

		if (result.success) {
			console.log('Assessment saved:', result.data);

			// Inject popup HTML
			const popupContainer = document.getElementById('popup-assessment-done');
			if (popupContainer && result.data.html) {
				popupContainer.innerHTML = result.data.html;
			}

			// Close current popup
			wpcore.closePopup("stage-assessment");

			// Show Success Popup
			wpcore.showPopup("stage-assessment-done");

			// Clear temp_weight cookie
			document.cookie = 'temp_weight=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

			// Reset form
			form.reset();
		} else {
			alert(wpcore.direct_t({ en: 'Error', fr: 'Erreur' }) + ': ' + (result.data?.message || wpcore.direct_t({ en: 'Failed to save assessment', fr: '\u00c9chec de l\'enregistrement de l\'\u00e9valuation' })));
			console.error('Save error:', result);
		}
	} catch (error) {
		alert(wpcore.direct_t({ en: 'Error: Failed to submit assessment. Please try again.', fr: 'Erreur : \u00c9chec de la soumission de l\'\u00e9valuation. Veuillez r\u00e9essayer.' }));
		console.error('Submission error:', error);
	} finally {
		submitBtn.disabled = false;
		submitBtn.textContent = originalText;
	}
};

/**
 * Initialize Assessment Form
 */
export function initAssessmentFormSubmit() {
	const form = document.getElementById('assessment-form');
	if (!form) return;

	form.addEventListener('submit', (e) => handleSubmit(e, form));
}


export function handleClosePopupDone() {
	document.addEventListener('popup-closed', (e) => {
		if (e.detail.target === 'stage-assessment-done') {
			window.location.reload();
		}
	})
}
